export interface OrganizationInfo {
  name: string;
  logoUrl: string | null;
}

export interface RawOrganizationInfo {
  name: string;
  logo_url: string | null;
}

export function normalizeOrganization(
  raw: RawOrganizationInfo | undefined,
): OrganizationInfo | undefined {
  return raw ? {name: raw.name, logoUrl: raw.logo_url} : undefined;
}

interface TokenPayload {
  token: string;
  expires_at: string;
  organization_identifier: string;
  refresh_token?: string;
  refresh_token_expires_at?: string;
}

export interface TokenSuccessResponse {
  data: TokenPayload;
}

// An anonymous identity exists only as its refresh token, so the tokens
// endpoint returns one whenever it mints or renews an anonymous session. A
// verified credential was issued by OTP and is recognised without a new one.
export function isAnonymousSession(response: TokenSuccessResponse): boolean {
  return response.data.refresh_token !== undefined;
}

export interface VerificationRequiredResponse {
  verification_required: true;
  organization?: OrganizationInfo;
}

export type RawTokenResponse =
  | TokenSuccessResponse
  | {
      verification_required: true;
      organization?: RawOrganizationInfo;
    };

export type TokenResponse = TokenSuccessResponse | VerificationRequiredResponse;

export function normalizeTokenResponse(raw: RawTokenResponse): TokenResponse {
  if ('data' in raw) {
    return raw;
  }
  return {
    verification_required: true,
    organization: normalizeOrganization(raw.organization),
  };
}

export function isTokenSuccess(
  response: TokenResponse,
): response is TokenSuccessResponse {
  return 'data' in response;
}

export interface VerifyRequestResponse {
  status: 'sent';
}

export interface VerifyConfirmResponse {
  data: Omit<TokenPayload, 'refresh_token' | 'refresh_token_expires_at'> & {
    refresh_token: string;
    refresh_token_expires_at: string;
  };
}
